import React from "react";
import { Box } from "Components/Base/Layout/Box";
import { ViewListIcon, ViewModuleIcon } from "Components/Icons";
import { STYLE_ICON } from "../styles";

/**
 * Gets view options array for the view selector
 * @param {Function} languageContext - Language context function
 * @returns {Array} Array of view option objects with value and label
 */
export const getViewOptions = (languageContext) => [
  {
    value: "list",
    label: (
      <Box display="flex" alignItems="center">
        <ViewListIcon fontSize="small" sx={STYLE_ICON} />
        {languageContext("ListView")}
      </Box>
    ),
  },
  {
    value: "card",
    label: (
      <Box display="flex" alignItems="center">
        <ViewModuleIcon fontSize="small" sx={STYLE_ICON} />
        {languageContext("cardView")}
      </Box>
    ),
  },
];
